module.exports = __webpack_public_path__ + "media/images/star-debbd689.svg";